import React, { useState } from "react";
import { connect } from "react-redux";
import ReactSelect, { components } from "react-select";
import { setEventStatsLanguage } from "../../../actions/actions/eventStats";
import CheckBoxBtn from "../../common/Checkbox/CheckBoxBtn";

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'} />
    </components.DropdownIndicator>
  );
};

const LanguageFilter = ({ eventStatsFilter, setEventStatsLanguage }) => {

  const [showMenu, setShowMenu] = useState(false);

  const handleSelectChange = (value) => {
    let languages = eventStatsFilter.language;
    const index = languages.indexOf(value);

    if (languages.includes("ALL")) {
      languages = ['FR', 'EN', 'NL'];
      languages.splice(languages.indexOf(value), 1);
      setEventStatsLanguage(languages);
    } else if (index > -1) {
      if (languages.length === 1) {
        return;
      } else {
        languages.splice(index, 1);
        setEventStatsLanguage(languages);
      }
    } else if (index === -1) {
      if (languages.length === 2) {
        languages = ["ALL"];
        setEventStatsLanguage(languages);
      } else {
        languages.push(value);
        setEventStatsLanguage(languages);
      }
    }
  };

  const handleChevronClick = () => {
    setShowMenu(!showMenu);
  };

  const pageSizeOptions = [
    { value: 'EN', label: 'ANGLAIS' },
    { value: 'FR', label: 'FRANÇAIS' },
    { value: 'NL', label: 'NEERLANDAIS' },
  ];

  return (
    <div className={'language-filter-container'}>
      <div className={'ml-3'}>Langues</div>
      <div className={'mr-3 ml-auto'}>
        <img
          src={"/img/icons/Polygon.svg"}
          className={showMenu && 'chevron-rotate'}
          onClick={() => handleChevronClick()}
        />
      </div>
      {showMenu && (
        <div className={'language-menu'}>
          {pageSizeOptions.map((item, index) => (
            <div className="customed_select_body_item" key={index}>
              <div>
                <CheckBoxBtn
                  id={item.value}
                  checked={eventStatsFilter.language.includes(item.value) || eventStatsFilter.language.includes('ALL')}
                  onChange={() => handleSelectChange(item.value)}
                />
              </div>
              <div className="customed_select_body_item_label">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  setEventStatsLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageFilter);


// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/LanguageFilter.js